/* =====================================================================
   nt-fx-g4.js: faq da home nova (sections/nt-fx-faq.liquid)
   abas trackers / mouth tracker (clique e setas do teclado) e o "ver todas as perguntas".
   o acordeao e o details nativo: abre, fecha e acha no ctrl+f sem js.
   sem js as abas ficam escondidas e os grupos aparecem inteiros, cada um com o seu titulo.
   ===================================================================== */
(function () {
  if (customElements.get('nt-fx-faq')) return;

  customElements.define(
    'nt-fx-faq',
    class extends HTMLElement {
      connectedCallback() {
        if (this.pronto) return;
        this.pronto = true;
        this.abas = Array.prototype.slice.call(this.querySelectorAll('[data-faq-aba]'));
        this.paineis = Array.prototype.slice.call(this.querySelectorAll('[data-faq-painel]'));
        var barra = this.querySelector('[data-faq-abas]');

        if (barra && this.abas.length > 1) {
          barra.hidden = false;
          this.querySelectorAll('[data-faq-grupo-titulo]').forEach(function (t) { t.hidden = true; });
          this.abas.forEach(function (aba, i) {
            aba.addEventListener('click', function () { this.ativar(aba, false); }.bind(this));
            aba.addEventListener('keydown', function (e) {
              var n = e.key === 'ArrowRight' ? 1 : e.key === 'ArrowLeft' ? -1 : 0;
              var total = this.abas.length;
              if (e.key === 'Home') { e.preventDefault(); this.ativar(this.abas[0], true); }
              else if (e.key === 'End') { e.preventDefault(); this.ativar(this.abas[total - 1], true); }
              else if (n) { e.preventDefault(); this.ativar(this.abas[(i + n + total) % total], true); }
            }.bind(this));
          }, this);
          var ativa = this.abas.filter(function (a) { return a.getAttribute('aria-selected') === 'true'; })[0] || this.abas[0];
          this.ativar(ativa, false);
        }

        // a lista comeca curta (o numero vem do editor; o css esconde o resto) e o botao abre tudo,
        // levando o foco para a primeira pergunta que estava escondida. aberta, o mesmo botao recolhe
        this.paineis.forEach(function (painel) {
          var ver = painel.querySelector('[data-faq-ver]');
          if (!ver) return;
          painel.classList.add('is-curto', 'tem-ver');
          ver.addEventListener('click', function () {
            if (painel.classList.contains('is-curto')) this.abrirTudo(painel, true);
            else this.recolher(painel);
          }.bind(this));
        }, this);

        // editor de temas: escolher uma pergunta escondida (outra aba ou depois do corte) mostra a pergunta
        this.aoEscolher = function (e) {
          var bloco = e.target;
          if (!bloco || !this.contains(bloco)) return;
          var painel = bloco.closest('[data-faq-painel]');
          if (!painel) return;
          var aba = this.abas.filter(function (a) { return a.getAttribute('data-faq-aba') === painel.getAttribute('data-faq-painel'); })[0];
          if (aba) this.ativar(aba, false);
          if (!bloco.getClientRects().length) this.abrirTudo(painel, false);
          if (bloco.tagName === 'DETAILS') bloco.open = true;
        }.bind(this);
        document.addEventListener('shopify:block:select', this.aoEscolher);
      }

      disconnectedCallback() {
        if (this.aoEscolher) document.removeEventListener('shopify:block:select', this.aoEscolher);
      }

      ativar(aba, foco) {
        var chave = aba.getAttribute('data-faq-aba');
        this.abas.forEach(function (a) {
          var ligada = a === aba;
          a.setAttribute('aria-selected', ligada ? 'true' : 'false');
          a.tabIndex = ligada ? 0 : -1;
        });
        this.paineis.forEach(function (p) {
          p.hidden = p.getAttribute('data-faq-painel') !== chave;
        });
        if (foco) aba.focus();
      }

      rotular(ver, aberta) {
        ver.setAttribute('aria-expanded', aberta ? 'true' : 'false');
        var txt = ver.querySelector('[data-faq-ver-txt]');
        var rotulo = ver.getAttribute(aberta ? 'data-ver-menos' : 'data-ver-todas');
        if (txt && rotulo) txt.textContent = rotulo;
      }

      abrirTudo(painel, foco) {
        if (!painel.classList.contains('is-curto')) return;
        var itens = Array.prototype.slice.call(painel.querySelectorAll('.s-faq__item'));
        var proxima = itens.filter(function (d) { return !d.getClientRects().length; })[0];
        painel.classList.remove('is-curto');
        var ver = painel.querySelector('[data-faq-ver]');
        if (ver) this.rotular(ver, true);
        if (foco && proxima) proxima.querySelector('summary').focus();
      }

      // volta a lista curta sem a pagina pular: o botao fica no mesmo lugar da tela
      recolher(painel) {
        var ver = painel.querySelector('[data-faq-ver]');
        var antes = ver ? ver.getBoundingClientRect().top : 0;
        painel.classList.add('is-curto');
        painel.querySelectorAll('.s-faq__item[open]').forEach(function (d) {
          if (!d.getClientRects().length) d.open = false;
        });
        if (!ver) return;
        this.rotular(ver, false);
        var depois = ver.getBoundingClientRect().top;
        if (depois !== antes) window.scrollBy({ top: depois - antes, left: 0, behavior: 'instant' });
        ver.focus();
      }
    }
  );
})();
